import { checkStatus, parseJSON } from '@rsos/utils';
import { getAPIHost } from '@rsos/utils/metaTags';
import fetchRetry from '../fetchRetry';
import {
  FETCH_ALL_INTEGRATION_CREDENTIALS_START,
  FETCH_ALL_INTEGRATION_CREDENTIALS_SUCCESS,
  FETCH_ALL_INTEGRATION_CREDENTIALS_ERROR,
} from './types';

const baseURL = `${getAPIHost()}/v1/capstone`;

export const fetchAllIntegrationCredentialsStart = () => ({
  type: FETCH_ALL_INTEGRATION_CREDENTIALS_START,
});

export const fetchAllIntegrationCredentialsSuccess = data => ({
  type: FETCH_ALL_INTEGRATION_CREDENTIALS_SUCCESS,
  payload: data,
});

export const fetchAllIntegrationCredentialsFailed = error => ({
  type: FETCH_ALL_INTEGRATION_CREDENTIALS_ERROR,
  payload: error,
});

/**
 * fetches all credentials for Inbound page
 * @param {String} orgID - sinatra org id
 */

export const fetchAllIntegrationCredentials = orgID => async dispatch => {
  dispatch(fetchAllIntegrationCredentialsStart());
  try {
    const response = await fetchRetry(
      `${baseURL}/psaps/${orgID}/authority-credentials`,
    )
      .then(checkStatus)
      .then(parseJSON)
      .then(responses => {
        return responses;
      });
    return dispatch(fetchAllIntegrationCredentialsSuccess(response));
  } catch (error) {
    return error;
  }
};

export default fetchAllIntegrationCredentials;
